// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDaAvqlgxOPpJTLA1KpdqccZpGcQNYmKgk",
  authDomain: "chat-app-dc029.firebaseapp.com",
  projectId: "chat-app-dc029",
  storageBucket: "chat-app-dc029.appspot.com",
  messagingSenderId: "105338035422",
  appId: "1:105338035422:web:048b2f2455bab5702d764f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const db = getFirestore(app)